import { merge } from "lodash";

import getTypePolicies from "./getTypePolicies";

export default ({ apolloCacheOptions }) =>
  merge({}, apolloCacheOptions, {
    typePolicies: getTypePolicies({
      options: apolloCacheOptions?.typePolicies ?? {}
    })
  });
